document.addEventListener('DOMContentLoaded', () => {

  const forms = document.querySelectorAll('[data-catalogue-form]');

  forms.forEach((form) => {

    form.addEventListener('submit', function(event) {

      event.preventDefault();

      const email =
        form.querySelector('[data-field="email"]')
          .value
          .trim();

      if (!email) {

        alert('Please enter your email');

        return;

      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {

        alert('Please enter valid email');

        return;

      }

      const submitBtn =
        form.querySelector('button[type="submit"]');

      if (submitBtn) {

        submitBtn.disabled = true;

        submitBtn.textContent = 'Submitting...';

      }

      const queryParams = new URLSearchParams({
        email: email,
        source: 'catalogue-download'
      }).toString();

      const callbackName =
        'handleCatalogueResponse' + Date.now();

      window[callbackName] = function(response) {

        console.log('Google Script Response:', response);

        delete window[callbackName];

        submitBtn.disabled = false;

        submitBtn.textContent = 'Download Now';

        const modal =
          form.closest('[class*="catalogue-modal"]');

        if (modal) {

          modal.classList.remove('active');

        }

      };

      const script = document.createElement('script');

      script.src =
        `https://script.google.com/macros/s/AKfycby6zvWT_oIcqdFpv0sTFhGRErBi0SVWEdtdaZwKATCdApuBkp7VsA1zJY6GsvT6xPNTRg/exec?${queryParams}&callback=${callbackName}`;

      script.onerror = function () {

        submitBtn.disabled = false;

        submitBtn.textContent = 'Download Now';

        alert('Failed to submit form');

      };

      document.body.appendChild(script);

    });

  });
});